var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.546875,
    y: 0.862183,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7435 21.5946H23.9302C21.8783 21.5946 20.2148 23.258 20.2148 25.31V59.7677C20.2148 61.8196 21.8783 63.483 23.9302 63.483H58.7435C60.7955 63.483 62.4589 61.8196 62.4589 59.7677V25.31C62.4589 23.258 60.7955 21.5946 58.7435 21.5946Z",
    fill: "#F8F7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0312 41.517C46.0312 39.4651 47.6947 37.8016 49.7466 37.8016H61.9133C62.7172 37.8016 63.4994 38.0624 64.1425 38.5447L74.506 46.3173C75.4415 47.019 75.9921 48.1202 75.9921 49.2896V59.767C75.9921 61.8189 74.3287 63.4824 72.2768 63.4824H49.7466C47.6947 63.4824 46.0312 61.8189 46.0312 59.767V41.517Z",
    fill: "#FE6533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1924 75.2412C38.2963 75.2412 41.6231 71.9143 41.6231 67.8105C41.6231 63.7066 38.2963 60.3798 34.1924 60.3798C30.0886 60.3798 26.7617 63.7066 26.7617 67.8105C26.7617 71.9143 30.0886 75.2412 34.1924 75.2412Z",
    fill: "#FE6533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8448 75.2441C68.9486 75.2441 72.2755 71.9173 72.2755 67.8134C72.2755 63.7095 68.9486 60.3827 64.8448 60.3827C60.7409 60.3827 57.4141 63.7095 57.4141 67.8134C57.4141 71.9173 60.7409 75.2441 64.8448 75.2441Z",
    fill: "#F8F7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/Transport.e3b069c6fd079b20bee220191039a00e.svg";
export { ForwardRef as ReactComponent };